module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_mascotas.6433ccc4.jpg";